<template>
  <div id="app">
    <router-view />
  </div>
</template>

<style lang="scss">
</style>
<script>
export default {
  name: "App",
  components: {},
  data() {
    return {};
  },
  created() {},
  async mounted() {
    // 动态加载字体
    const fontPath = process.env.VUE_APP_FONT_PATH;
    const style = document.createElement("style");
    style.type = "text/css";
    style.innerHTML = `
      @font-face {
        font-family: 'IMSansQH';
        src: url('${fontPath}') format('truetype');
        font-weight: normal;
        font-style: normal;
        font-display: swap;
      }
    `;
    document.head.appendChild(style);
  },
  watch: {}
};
</script>